import { useState } from 'react';

const navLinks = [
  { href: '#cover', label: '封面风格' },
  { href: '#palette', label: '海报配色' },
  { href: '#layout', label: '版式灵感' },
  { href: '#tune', label: '调色参数' },
  { href: '#heat', label: '热度榜' },
];

export default function TopNav() {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 border-b border-background-300/60 bg-background-50/85 backdrop-blur-md">
      <div className="mx-auto flex h-16 items-center justify-between gap-4 px-4 md:px-6">
        <a href="#top" className="flex shrink-0 items-center gap-2.5">
          <span className="flex h-9 w-9 items-center justify-center rounded-md bg-foreground-950 text-base font-bold text-primary-300">
            黑
          </span>
          <span className="font-display text-lg font-bold tracking-tight text-foreground-950">
            黑料色<span className="text-primary-500">灵感库</span>
          </span>
        </a>

        <nav className="hidden items-center gap-1 md:flex">
          {navLinks.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="whitespace-nowrap rounded-full px-3.5 py-2 text-sm text-foreground-700 transition-colors hover:bg-background-200/70 hover:text-foreground-950"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="hidden items-center gap-3 lg:flex">
          <button
            type="button"
            className="flex h-9 cursor-pointer items-center gap-2 whitespace-nowrap rounded-full border border-background-300/70 bg-background-50 px-3 text-sm text-foreground-600 transition-colors hover:border-primary-300 hover:text-foreground-900"
            aria-label="搜索灵感"
          >
            <i className="ri-search-line text-[15px]" />
            <span className="text-foreground-500">搜配色 / 版式</span>
          </button>
          <a
            href="#cover"
            className="flex h-9 cursor-pointer items-center whitespace-nowrap rounded-full bg-primary-500 px-4 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
          >
            开始翻灵感
          </a>
        </div>

        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-md border border-background-300/70 bg-background-50 text-foreground-800 md:hidden"
          aria-label="打开菜单"
        >
          <i className={open ? 'ri-close-line text-xl' : 'ri-menu-line text-xl'} />
        </button>
      </div>

      {open && (
        <div className="border-t border-background-300/60 bg-background-50 px-4 py-3 md:hidden">
          <nav className="flex flex-col gap-1">
            {navLinks.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="flex cursor-pointer items-center justify-between rounded-lg px-3 py-2.5 text-sm text-foreground-800 transition-colors hover:bg-background-200/70"
              >
                {l.label}
                <i className="ri-arrow-right-s-line text-foreground-400" />
              </a>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}